import { Role } from '@/routes/PrivateRoute';
import useAuth from '@/hooks/useAuth';

// V2 Order Flow is restricted to tenant admins only.

const useOrderFlowV2Enabled = (): boolean => {
  const { currentAdmin } = useAuth();
  return currentAdmin?.role === Role.TENANT_ADMIN;
};

export default useOrderFlowV2Enabled;
